
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { SMUser, SMCases } from "@/store";

import { WARNING_POPUP_TYPE } from "@/constants/popupTypes";

@Component
export default class ArchivePopup extends Vue {
  @Prop({ type: Boolean, default: false }) readonly show!: boolean;
  @Prop({ type: String, default: WARNING_POPUP_TYPE }) readonly type!: string;

  showPopup = false;

  @Watch("show", { immediate: true })
  showPopupChanged(val: boolean) {
    this.showPopup = val;
  }

  open() {
    this.showPopup = true;
  }

  close() {
    this.showPopup = false;

    this.$emit("close");
  }

  get caseId() {
    return Number(this.$route.params.id ?? 0);
  }

  get archiveEndpoint(): string {
    if (!this.caseId) return "";

    if (SMUser.isExpert) return API_ROUTES.EXPERT_CASE_ARCHIVE(this.caseId);

    if (SMUser.isEmployer) return API_ROUTES.CASE_ARCHIVE(this.caseId);

    return "";
  }

  archiveLoading = false;

  async archiveCandidate() {
    try {
      this.archiveLoading = true;

      await this.axios.get(this.archiveEndpoint);

      SMCases.setIsArchived(true);

      this.close();
    } finally {
      this.archiveLoading = false;
    }
  }
}
